import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import styles from './DotsLoader.styles';
import { DOT_PROPS, PROPS } from './DotsLoader.utils';

function DotsLoader({ label, activeDots }: PROPS) {
  return (
    <Stack
      sx={styles.wrapper}
      alignItems="center"
      spacing="8px"
      data-testid="dots-loader"
    >
      <Stack spacing="7px" direction="row">
        <Dot active={activeDots.includes('1')} />
        <Dot active={activeDots.includes('2')} />
        <Dot active={activeDots.includes('3')} />
      </Stack>
      <Typography sx={styles.label}>{label}</Typography>
    </Stack>
  );
}

function Dot({ active }: DOT_PROPS) {
  return (
    <Box
      sx={{ ...styles.dot, ...(active ? { ...styles.dot.active } : {}) }}
    ></Box>
  );
}

export default DotsLoader;
